import * as PublicWifiPxsplusActions from './../actions/public-wifi-pxsplus.actions';
import { TechnicalError } from '@dch/products-business-logic';

export interface IPublicWifiProduct {
  productDescription: string;
  serviceType: 'INTERNET' | 'MOBILE';
  serviceId: string;
  configured: boolean;
}

export interface PublicWifiPxsplusState {
  jwt: any;
  isPendingProducts: boolean;
  products: Array<IPublicWifiProduct>;
  errorProducts: TechnicalError;
  configureUrl: string;
  getConfigureUrlPending: boolean;
  getConfigureUrlSuccess: boolean;
  getConfigureUrlError: TechnicalError;
}

export const initialState: PublicWifiPxsplusState = {
  jwt: null,
  isPendingProducts: false,
  products: [],
  errorProducts: null,
  configureUrl: '',
  getConfigureUrlPending: false,
  getConfigureUrlSuccess: false,
  getConfigureUrlError: null,
};

export function reducer(
  state: PublicWifiPxsplusState = initialState,
  action: PublicWifiPxsplusActions.Actions,
): PublicWifiPxsplusState {
  switch (action.type) {
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS:
      return {
        ...state,
        jwt: null,
        isPendingProducts: true,
        products: [],
        errorProducts: null,
      };
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_SUCCESS:
      return {
        ...state,
        jwt: action.payload.headers[
          'x-application-authorization-products-data'
        ],
        products: action.payload.value.products,
        isPendingProducts: false,
        errorProducts: null,
      };
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_PRODUCTS_FAILED:
      return {
        ...state,
        jwt: null,
        isPendingProducts: false,
        products: [],
        errorProducts: action.payload,
      };
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL:
      return {
        ...state,
        configureUrl: undefined,
        getConfigureUrlPending: true,
        getConfigureUrlError: null,
        getConfigureUrlSuccess: false,
      };
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_SUCCESS:
      return {
        ...state,
        configureUrl: action.payload.link,
        getConfigureUrlPending: false,
        getConfigureUrlError: null,
        getConfigureUrlSuccess: true,
      };
    case PublicWifiPxsplusActions.GET_PUBLIC_WIFI_PXSPLUS_CONFIGURE_URL_FAILED:
      return {
        ...state,
        configureUrl: undefined,
        getConfigureUrlPending: false,
        getConfigureUrlError: action.payload,
        getConfigureUrlSuccess: false,
      };
    default:
      return state;
  }
}

export const getProductsJwt = (state: PublicWifiPxsplusState) => state.jwt;
export const getEligibleProducts = (state: PublicWifiPxsplusState) =>
  state.products;
export const getProductsError = (state: PublicWifiPxsplusState) =>
  state.errorProducts;
export const getProductsPending = (state: PublicWifiPxsplusState) =>
  state.isPendingProducts;
export const getConfigureURL = (state: PublicWifiPxsplusState) =>
  state.configureUrl;
export const getConfigureURLSuccess = (state: PublicWifiPxsplusState) =>
  state.getConfigureUrlSuccess;
export const getConfigureURLError = (state: PublicWifiPxsplusState) =>
  state.getConfigureUrlError;
export const getConfigureURLPending = (state: PublicWifiPxsplusState) =>
  state.getConfigureUrlPending;
